// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_n8-0";